import { render, staticRenderFns } from "./AppointmentDetailedReport.vue?vue&type=template&id=21f94a0c&"
import script from "./AppointmentDetailedReport.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDetailedReport.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentDetailedReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports